import React from 'react'
import styled from '@emotion/styled'
import { useMe } from '../services'
import { Header1, Text } from '../styles/Components'
import { gsColors } from '../styles/Variables'
import { mq } from '../helpers'
import Link from 'next/link'

const FormHeader = React.forwardRef(({ title, content, redirect }, ref) => {
  const me = useMe()
  return (
    <FormHeaderContainer ref={ref}>
      <Header1 align="center" color={gsColors.black}>
        {title}
      </Header1>
      <Text fontSize={24} lineHeight="140%" spacing="0.24px">
        {content}
      </Text>
      {!me && (
        <span>
          <Text weight={600} fontSize={24} lineHeight="120%">
            For a quicker experience,
          </Text>
          <Link href={`/signin?onSuccess=${redirect}`}>sign in</Link>
          <Text weight={600} fontSize={24} lineHeight="120%">
            to your account.
          </Text>
        </span>
      )}
    </FormHeaderContainer>
  )
})

export default FormHeader

const FormHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f4ef;
  width: 100%;
  gap: 30px;
  padding: 60px 0 80px;
  box-sizing: border-box;

  ${mq('max', '768px')} {
    padding: 40px 16px;
  }

  h1 {
    max-width: 700px;
    box-sizing: border-box;
    word-wrap: break-word;
    text-align: center;
    min-width: 0;
    text-transform: uppercase;
  }

  p {
    max-width: 800px;
    text-align: center;
  }

  span {
    display: inline;
    white-space: normal;
    word-break: break-word;
    text-align: center;

    p,
    a {
      display: inline;
    }
    ${mq('max', '768px')} {
    }

    p {
      text-align: center;
    }

    a {
      color: ${gsColors.cobalt};
      line-height: 1.25;
      margin: 0 6px;
      font-size: 24px;
      font-weight: 600;

      ${mq('max', '768px')} {
        font-size: 18px;
      }
    }
  }
`
